import React from 'react';
import { withStyles } from '@material-ui/styles';
import { Button, Tooltip } from '@material-ui/core';
import flowRight from 'lodash.flowright';

import styles from './styles/successButton';
import withSettings from '../../utils/withSettings';
import DEFAULT_FRONTEND_SETTINGS from '../../consts/frontendSettings';
import Optional from '../../utils/optional';

const SuccessButton = ({
  children,
  onClick,
  classes,
  settings,
  disabled = false,
  tooltipOnDisabled = ''
}) => {
  return (
    <Tooltip title={disabled ? tooltipOnDisabled : ''}>
      <span>
        <Button
          className={classes.root}
          style={{
            backgroundColor: !disabled
              ? Optional(settings)
                  .map(settings => settings.colors.success)
                  .or(DEFAULT_FRONTEND_SETTINGS.colors.success)
              : '#E0E0E0',
            color: !disabled
              ? Optional(settings)
                  .map(settings => settings.colors.white)
                  .or(DEFAULT_FRONTEND_SETTINGS.colors.white)
              : 'rgba(0, 0, 0, 0.26)'
          }}
          disabled={disabled}
          onClick={onClick}
        >
          {children}
        </Button>
      </span>
    </Tooltip>
  );
};

export default flowRight(withSettings, withStyles(styles))(SuccessButton);
